import React, { Component } from "react";
import "semantic-ui-css/semantic.min.css";
import { Button, Modal } from "semantic-ui-react";
import "../css/home.css";
import "../css/index.css";

const footerStyle = {
  backgroundColor: "#102138",
  padding: "1rem",
  margin: 0,
  maxWidth: "100%",
  boxSizing: "border-box",
};

const linksRowStyle = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  alignItems: "center",
  gap: "0.5rem 1rem",
  paddingBottom: "0.75rem",
  borderBottom: "1px solid rgba(212, 160, 23, 0.3)",
};

const linkStyle = {
  color: "#B0C4DE",
  fontSize: "0.9rem",
  cursor: "pointer",
  textDecoration: "none",
  transition: "color 0.2s ease",
  background: "none",
  border: "none",
  padding: 0,
  fontFamily: "inherit",
};

const separatorStyle = {
  color: "rgba(212, 160, 23, 0.6)",
  fontSize: "0.7rem",
  userSelect: "none",
};

const disclaimerStyle = {
  color: "rgba(176, 196, 222, 0.9)",
  fontSize: "0.8rem",
  lineHeight: 1.5,
  marginTop: "0.75rem",
  marginBottom: 0,
  textAlign: "center",
  maxWidth: "720px",
  marginLeft: "auto",
  marginRight: "auto",
};

const copyrightStyle = {
  color: "rgba(176, 196, 222, 0.7)",
  fontSize: "0.75rem",
  marginTop: "0.75rem",
  textAlign: "center",
};

export default class Footer extends Component {
  state = {
    modalOpen: false,
    aboutUsModalOpen: false,
    privacyModalOpen: false,
  };

  handleModalToggle = () =>
    this.setState((prevState) => ({ modalOpen: !prevState.modalOpen }));

  handleAboutUsModalToggle = () =>
    this.setState((prevState) => ({
      aboutUsModalOpen: !prevState.aboutUsModalOpen,
    }));

  handlePrivacyModalToggle = () =>
    this.setState((prevState) => ({
      privacyModalOpen: !prevState.privacyModalOpen,
    }));

  handleLinkClick = (page) => {
    if (this.props.onNavigate) {
      this.props.onNavigate(page);
    } else if (page === "about") {
      this.handleAboutUsModalToggle();
    } else if (page === "terms") {
      this.handleModalToggle();
    } else if (page === "privacy") {
      this.handlePrivacyModalToggle();
    }
  };

  render() {
    const usePageNav = !!this.props.onNavigate;

    return (
      <footer className="main-footer" style={footerStyle}>
        <div style={linksRowStyle}>
          <button
            className="footer-link"
            style={linkStyle}
            onClick={(e) => {
              e.preventDefault();
              this.handleLinkClick("about");
            }}
          >
            About Us
          </button>
          <span style={separatorStyle}>•</span>
          <button
            className="footer-link"
            style={linkStyle}
            onClick={(e) => {
              e.preventDefault();
              this.handleLinkClick("terms");
            }}
          >
            Terms
          </button>
          <span style={separatorStyle}>•</span>
          <button
            className="footer-link"
            style={linkStyle}
            onClick={(e) => {
              e.preventDefault();
              this.handleLinkClick("privacy");
            }}
          >
            Privacy
          </button>
        </div>
        <p className="footer-disclaimer" style={disclaimerStyle}>
          <strong>SimplyStock.net</strong> provides stock analysis for
          informational purposes only. We are not a stockbroker, dealer, or
          investment advisor. Information on this site does not constitute
          financial advice or a recommendation to buy or sell securities.
        </p>
        <p className="footer-copyright" style={copyrightStyle}>
          © {new Date().getFullYear()} SimplyStock.net. All rights reserved.
        </p>
        {!usePageNav && (
          <>
        {/* About Us Modal */}
        <Modal
          open={this.state.aboutUsModalOpen}
          onClose={this.handleAboutUsModalToggle}
          closeOnEscape={true}
          size="large"
          closeIcon
          dimmer="blurring"
        >
          <Modal.Header style={{ backgroundColor: "#102138", color: "white" }}>
            About Us
          </Modal.Header>
          <Modal.Content style={{ backgroundColor: "#ECEFF1", color: "#333" }}>
            <div
              style={{
                maxHeight: "500px",
                overflowY: "auto",
                padding: "1.5rem",
              }}
            >
              <h3 style={{ fontSize: "1.4rem" }}>
                Our Mission: Empowering Informed Investors
              </h3>
              <p style={{ fontSize: "1.1rem" }}>
                At SimplyStock.net, we believe that everyone should have access
                to clear and accurate financial data. Founded by a team of
                experienced financial analysts and technology experts, we are
                driven by a mission to demystify the stock market. We deliver
                robust tools, real-time data, and insightful analysis, enabling
                our users to navigate the complexities of investing with
                confidence. Our commitment lies in providing a user-friendly
                platform that supports your financial journey.
              </p>
            </div>
          </Modal.Content>
          <Modal.Actions style={{ backgroundColor: "#ECEFF1" }}>
            <Button onClick={this.handleAboutUsModalToggle}>Close</Button>
          </Modal.Actions>
        </Modal>
        {/* Terms and Conditions Modal (Existing Modal) */}
        <Modal
          open={this.state.modalOpen}
          onClose={this.handleModalToggle}
          closeOnEscape={true}
          size="large"
          closeIcon
          dimmer="blurring"
        >
          <Modal.Header style={{ backgroundColor: "#102138", color: "white" }}>
            Terms and Conditions
          </Modal.Header>
          <Modal.Content style={{ backgroundColor: "#ECEFF1", color: "#333" }}>
            <div
              style={{
                maxHeight: "500px",
                overflowY: "auto",
                padding: "1.5rem",
              }}
              dangerouslySetInnerHTML={{
                __html: `<h4>1. General Information</h4>
                <p style={{ fontSize: "1.1rem" }}>The content on SimplyStock.net is provided for informational purposes only and does not constitute financial or investment advice. We do not recommend the purchase or sale of any securities or stocks. All statements, analyses, and opinions are based on general information and should not be interpreted as personalized advice.</p>
                <h4>2. Independent Research</h4>
                <p style={{ fontSize: "1.1rem" }}>Users are encouraged to conduct their own research before making any investment decisions. SimplyStock is not responsible for any financial decisions made based on the content provided on this Website.</p>
                <h4>3. Accuracy and Disclaimer</h4>
                <p style={{ fontSize: "1.1rem" }}>While we make efforts to provide accurate and up-to-date information, SimplyStock does not guarantee the accuracy, completeness, or timeliness of the content on this Website. The content is provided "as is," and users bear all risks associated with reliance on it. We are not liable for any losses or damages resulting from the use of the Website.</p>
                <h4>4. Intellectual Property</h4>
                <p style={{ fontSize: "1.1rem" }}>All content on SimplyStock.net, including text, graphics, logos, and other materials, is the property of SimplyStock or its licensors. You may not republish, reproduce, distribute, or sell any content from this Website without written permission. Unauthorized sharing or distribution of content is prohibited.</p>
                <h4>5. Data Sources and Validation</h4>
                <p style={{ fontSize: "1.1rem" }}>The data on SimplyStock.net is sourced from third-party providers. While we strive to validate this data, there may be occasional inaccuracies or outdated information. We recommend verifying data with other trusted financial websites.</p>
                <h4>6. Data Refresh Rates</h4>
                <p style={{ fontSize: "1.1rem" }}>Financial data on the Website is refreshed periodically, such as annually or quarterly. The data displayed may differ from other financial websites due to variations in data update schedules.</p>
                <h4>7. Stock Coverage</h4>
                <p style={{ fontSize: "1.1rem" }}>SimplyStock does not provide analysis for all U.S. stocks. Currently, we only cover a limited set of companies, and do not provide data on newly public companies or mutual funds.</p>
                <h4>8. Termination of Access</h4>
                <p style={{ fontSize: "1.1rem" }}>We reserve the right to suspend, revoke, or terminate user access to the Website at our discretion, without prior notice, if any of these Terms are violated.</p>
                <h4>9. Limitation of Liability</h4>
                <p style={{ fontSize: "1.1rem" }}>SimplyStock and its affiliates are not responsible for any direct, indirect, incidental, or consequential damages arising from the use of this Website. Users use the Website at their own risk, and the Website is provided "as is."</p>
                <h4>10. Indemnification</h4>
                <p style={{ fontSize: "1.1rem" }}>By using this Website, you agree to indemnify and hold harmless SimplyStock and its affiliates from any claims, damages, or expenses arising from your use of the Website or violation of these Terms.</p>
                <h4>11. Changes to Terms</h4>
                <p style={{ fontSize: "1.1rem" }}>We may update or modify these Terms at any time. It is your responsibility to review these Terms periodically. By continuing to use the Website, you agree to any updates made to the Terms.</p>`,
              }}
            />
          </Modal.Content>
          <Modal.Actions style={{ backgroundColor: "#ECEFF1" }}>
            <Button onClick={this.handleModalToggle}>Close</Button>
          </Modal.Actions>
        </Modal>
        {/* Privacy Policy Modal */}
        <Modal
          open={this.state.privacyModalOpen}
          onClose={this.handlePrivacyModalToggle}
          closeOnEscape={true}
          size="large"
          closeIcon
          dimmer="blurring"
        >
          <Modal.Header style={{ backgroundColor: "#102138", color: "white" }}>
            Privacy Policy
          </Modal.Header>
          <Modal.Content style={{ backgroundColor: "#ECEFF1", color: "#333" }}>
            <div
              style={{
                maxHeight: "500px",
                overflowY: "auto",
                padding: "1.5rem",
              }}
            >
              <p style={{ fontSize: "1.1rem" }}>
                At SimplyStock.net, we are committed to protecting your privacy.
                This Privacy Policy outlines how we collect, use, and safeguard
                your information.
              </p>
              <h4 style={{ fontSize: "1.2rem" }}>Information We Collect</h4>
              <p style={{ fontSize: "1.1rem" }}>
                We may collect information you provide directly to us, such as
                your name and email address, when you register or subscribe to
                our services. We also collect data related to your usage of our
                platform, including IP addresses and browsing behavior, to
                improve our services and user experience.
              </p>
              <h4 style={{ fontSize: "1.2rem" }}>
                How We Use Your Information
              </h4>
              <p style={{ fontSize: "1.1rem" }}>
                Your information is used to provide and improve our services,
                personalize your experience, and communicate with you about
                updates and offers. We do not sell your personal information to
                third parties.
              </p>
              <h4 style={{ fontSize: "1.2rem" }}>Data Security</h4>
              <p style={{ fontSize: "1.1rem" }}>
                We implement robust security measures to protect your
                information from unauthorized access, alteration, or
                destruction.
              </p>
              <h4 style={{ fontSize: "1.2rem" }}>Changes to This Policy</h4>
              <p style={{ fontSize: "1.1rem" }}>
                We may update this Privacy Policy from time to time. We will
                notify you of any significant changes by posting the new policy
                on our website.
              </p>
              <h4 style={{ fontSize: "1.2rem" }}>Contact Us</h4>
              <p style={{ fontSize: "1.1rem" }}>
                If you have any questions about this Privacy Policy, please
                contact us at info@SimplyStock.net.
              </p>
            </div>
          </Modal.Content>
          <Modal.Actions style={{ backgroundColor: "#ECEFF1" }}>
            <Button onClick={this.handlePrivacyModalToggle}>Close</Button>
          </Modal.Actions>
        </Modal>
          </>
        )}
      </footer>
    );
  }
}
